import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Badge } from "@/components/ui/badge";
import { Switch } from "@/components/ui/switch";
import { Plus, Edit, Copy, Trash2 } from "lucide-react";

export function ValidationRulesLibrary() {
  const rules = [
    { code: 'REQ-001', name: 'Account Number Required', category: 'Required Fields', severity: 'Error', active: true },
    { code: 'REQ-002', name: 'Amount Due Required', category: 'Required Fields', severity: 'Error', active: true },
    { code: 'DQ-001', name: 'Positive Amount', category: 'Data Quality', severity: 'Warning', active: true },
    { code: 'DQ-002', name: 'Bill Date Not Future', category: 'Data Quality', severity: 'Error', active: true },
    { code: 'BL-001', name: 'Due After Bill Date', category: 'Business Logic', severity: 'Warning', active: true },
    { code: 'DUP-001', name: 'Duplicate Detection', category: 'Duplicate', severity: 'Error', active: true },
    { code: 'ANO-001', name: 'Consumption Spike', category: 'Anomaly', severity: 'Warning', active: true },
  ];

  return (
    <div className="space-y-6">
      <Card>
        <CardHeader>
          <div className="flex items-center justify-between">
            <div>
              <CardTitle>Validation Rules Library</CardTitle>
              <CardDescription>
                Configure business rules that run automatically when bills enter the validation stage
              </CardDescription>
            </div>
            <Button>
              <Plus className="h-4 w-4 mr-2" />
              Create Rule
            </Button>
          </div>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>Rule Code</TableHead>
                <TableHead>Name</TableHead>
                <TableHead>Category</TableHead>
                <TableHead>Severity</TableHead>
                <TableHead>Status</TableHead>
                <TableHead>Actions</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rules.map((rule) => (
                <TableRow key={rule.code}>
                  <TableCell className="font-mono text-sm">{rule.code}</TableCell>
                  <TableCell className="font-medium">{rule.name}</TableCell>
                  <TableCell>{rule.category}</TableCell>
                  <TableCell>
                    <Badge variant={rule.severity === 'Error' ? 'destructive' : 'default'}>
                      {rule.severity}
                    </Badge>
                  </TableCell>
                  <TableCell>
                    <Switch checked={rule.active} />
                  </TableCell>
                  <TableCell>
                    <div className="flex items-center gap-2">
                      <Button size="sm" variant="ghost">
                        <Edit className="h-4 w-4" />
                      </Button>
                      <Button size="sm" variant="ghost">
                        <Copy className="h-4 w-4" />
                      </Button>
                      <Button size="sm" variant="ghost">
                        <Trash2 className="h-4 w-4" />
                      </Button>
                    </div>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </CardContent>
      </Card>
    </div>
  );
}
